var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMegafone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "464pt",
    viewBox: "0 0 464 464",
    width: "464pt",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m352 432-224-128v-144l224-128zm0 0",
    fill: "#d6d6d4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m372 0c11.046875 0 20 8.953125 20 20v424c0 11.046875-8.953125 20-20 20s-20-8.953125-20-20v-424c0-11.046875 8.953125-20 20-20zm0 0",
    fill: "#e94f4f"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m32 160h96v144h-96zm0 0",
    fill: "#e94f4f"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m0 184h32v96h-32zm0 0",
    fill: "#d6d6d4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m464 264-72 16v-96l72 16zm0 0",
    fill: "#c9c9c7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m64 304h64v160h-64zm0 0",
    fill: "#d6d6d4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m56 184h16v32h-16zm0 0",
    fill: "#ba2727"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m88 184h16v32h-16zm0 0",
    fill: "#ba2727"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m302.554688 97.144531 13.332031-8.003906 8.234375 13.71875-13.332032 8.003906zm0 0",
    fill: "#ebebe9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m155.890625 185.160156 133.324219-80.023437 8.234375 13.714843-133.324219 80.023438zm0 0",
    fill: "#ebebe9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m352 146.703125c-56.984375 85.542969-135.617188 139.753906-198.089844 172.105469l198.089844 113.191406zm0 0",
    fill: "#c9c9c7"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m372 392c-11.046875 0-20-8.953125-20-20v72c0 11.046875 8.953125 20 20 20s20-8.953125 20-20v-72c0 11.046875-8.953125 20-20 20zm0 0",
    fill: "#cf3a3a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMegafone);
export default __webpack_public_path__ + "static/media/megafone.8459f261469f972638e4b82d8b3abeb8.svg";
export { ForwardRef as ReactComponent };